export const KeyLocalStore = {
  userSession: 'userSession'.trim(),
  accessToken: 'accessToken'.trim(),
  tenantId: 'tenantId'.trim(),
  language: 'language'.trim(),
};
